module.exports = __webpack_public_path__ + "static/media/Champ.748d786f.svg";